import React from "react";
import "./nodata.css";

function NoData(props) {
  return <div className="_noDataFound">{props.children}</div>;
}

export default NoData;
